"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updatePlaidItems = exports.updatePlaidItem = exports.savePlaidAuthLink = exports.saveFailedPlaidLink = exports.getPlaidAssets = exports.getAchLogins = exports.exchangePublicToken = exports.deletePlaidItem = exports.createPlaidLinkToken = exports.createPlaidItemPublicToken = exports.UPDATE_PLAID_ITEMS = exports.UPDATE_PLAID_ITEM = exports.SAVE_PLAID_AUTH_LINK = exports.SAVE_FAILED_PLAID_LINK = exports.GET_PLAID_ASSETS = exports.GET_ACH_LOGINS = exports.EXCHANGE_PLAID_PUBLIC_TOKEN = exports.DELETE_PLAID_ITEM = exports.CREATE_PLAID_LINK_TOKEN = exports.CREATE_PLAID_ITEM_PUBLIC_TOKEN = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _ajax = require("./ajax");

var _httpActions = require("./http-actions");

var GET_ACH_LOGINS = 'GET_ACH_LOGINS';
exports.GET_ACH_LOGINS = GET_ACH_LOGINS;
var SAVE_PLAID_AUTH_LINK = 'SAVE_PLAID_AUTH_LINK';
exports.SAVE_PLAID_AUTH_LINK = SAVE_PLAID_AUTH_LINK;
var SAVE_FAILED_PLAID_LINK = 'SAVE_FAILED_PLAID_LINK';
exports.SAVE_FAILED_PLAID_LINK = SAVE_FAILED_PLAID_LINK;
var GET_PLAID_ASSETS = 'GET_PLAID_ASSETS';
exports.GET_PLAID_ASSETS = GET_PLAID_ASSETS;
var CREATE_PLAID_ITEM_PUBLIC_TOKEN = 'CREATE_PLAID_ITEM_PUBLIC_TOKEN';
exports.CREATE_PLAID_ITEM_PUBLIC_TOKEN = CREATE_PLAID_ITEM_PUBLIC_TOKEN;
var CREATE_PLAID_LINK_TOKEN = 'CREATE_PLAID_LINK_TOKEN';
exports.CREATE_PLAID_LINK_TOKEN = CREATE_PLAID_LINK_TOKEN;
var EXCHANGE_PLAID_PUBLIC_TOKEN = 'EXCHANGE_PLAID_PUBLIC_TOKEN';
exports.EXCHANGE_PLAID_PUBLIC_TOKEN = EXCHANGE_PLAID_PUBLIC_TOKEN;
var UPDATE_PLAID_ITEM = 'UPDATE_PLAID_ITEM';
exports.UPDATE_PLAID_ITEM = UPDATE_PLAID_ITEM;
var DELETE_PLAID_ITEM = 'DELETE_PLAID_ITEM';
exports.DELETE_PLAID_ITEM = DELETE_PLAID_ITEM;
var UPDATE_PLAID_ITEMS = 'UPDATE_PLAID_ITEMS';
exports.UPDATE_PLAID_ITEMS = UPDATE_PLAID_ITEMS;
var PROFILE_CONTEXT = '/service-profile/api/v1/ach';
var PLAID_CONTEXT = '/plaid/api/v1/authlink';
/**
 * Get a list of Plaid checking accounts.
 */

var getAchLogins = function getAchLogins() {
  var showSpinner = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  return /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(dispatch) {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", (0, _ajax.ajaxGet)(GET_ACH_LOGINS, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(PROFILE_CONTEXT, "/logins"), null, null, showSpinner));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
/**
 * Save Plaid auth link for pulling assets.
 * @param {String} publicToken
 * @param {Object} data https://plaid.com/docs/#onsuccess-callback
 * @param {Boolean} showSpinner Whether or not to show the loading animation
 */


exports.getAchLogins = getAchLogins;

var savePlaidAuthLink = function savePlaidAuthLink(accessToken, data) {
  var showSpinner = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(dispatch) {
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", (0, _ajax.ajaxPost)(SAVE_PLAID_AUTH_LINK, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(PLAID_CONTEXT, "/").concat(accessToken), data, null, showSpinner));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};
/**
 * Saves data from a failed Plaid link.
 * @param {Object} data {
 *   linkError: {
 *     error_type: String,
 *     error_code: String,
 *     error_message: String,
 *     display_message: String,
 *   },
 *   linkErrorMetadata: {
 *     link_session_id: String,
 *     request_id: String,
 *     institution: {
 *       name: String,
 *       institution_id: String,
 *     },
 *     status: String,
 *   }
 * }
 * @param {Boolean} showSpinner Whether or not to show the loading animation
 */


exports.savePlaidAuthLink = savePlaidAuthLink;

var saveFailedPlaidLink = function saveFailedPlaidLink(data) {
  var showSpinner = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(dispatch) {
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", (0, _ajax.ajaxPost)(SAVE_FAILED_PLAID_LINK, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(PLAID_CONTEXT, "/storeLinkError"), data, null, showSpinner));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
};
/**
 * Get a list of all Plaid assets for this identity.
 * @param {Boolean} showSpinner Whether or not to show the loading animation
 */


exports.saveFailedPlaidLink = saveFailedPlaidLink;

var getPlaidAssets = function getPlaidAssets() {
  var showSpinner = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  return /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(dispatch) {
      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", (0, _ajax.ajaxGet)(GET_PLAID_ASSETS, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(PLAID_CONTEXT, "/asset"), null, null, showSpinner));

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function (_x4) {
      return _ref4.apply(this, arguments);
    };
  }();
};
/**
 * @deprecated no longer used due to Plaid Link Token migration
 *
 * Get a public token for an item so that we can Link update it.
 * @param {String} uuid
 */


exports.getPlaidAssets = getPlaidAssets;

var createPlaidItemPublicToken = function createPlaidItemPublicToken(uuid) {
  return /*#__PURE__*/function () {
    var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(dispatch) {
      return _regenerator.default.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt("return", (0, _ajax.ajaxGet)(CREATE_PLAID_ITEM_PUBLIC_TOKEN, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(PLAID_CONTEXT, "/publicTokenCreate/").concat(uuid)));

            case 1:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function (_x5) {
      return _ref5.apply(this, arguments);
    };
  }();
};
/**
 * Create and get link token to initialize Link
 * @param {Object} data
 * @param {String} data.clientName Name to display when opening Plaid Link
 */


exports.createPlaidItemPublicToken = createPlaidItemPublicToken;

var createPlaidLinkToken = function createPlaidLinkToken(data) {
  return /*#__PURE__*/function () {
    var _ref6 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(dispatch) {
      return _regenerator.default.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt("return", (0, _ajax.ajaxPost)(CREATE_PLAID_LINK_TOKEN, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(PLAID_CONTEXT, "/linkTokenCreate"), data));

            case 1:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function (_x6) {
      return _ref6.apply(this, arguments);
    };
  }();
};
/**
 * Exchanges the public token for an access token
 * @param {String} publicToken
 * @returns {String} access token
 */


exports.createPlaidLinkToken = createPlaidLinkToken;

var exchangePublicToken = function exchangePublicToken(publicToken) {
  return /*#__PURE__*/function () {
    var _ref7 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7(dispatch) {
      return _regenerator.default.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt("return", (0, _ajax.ajaxGet)(EXCHANGE_PLAID_PUBLIC_TOKEN, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(PLAID_CONTEXT, "/publicTokenExchange/").concat(publicToken)));

            case 1:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    return function (_x7) {
      return _ref7.apply(this, arguments);
    };
  }();
};
/**
 * Pull asset report for an item uuid.
 * @param {String} uuid
 */


exports.exchangePublicToken = exchangePublicToken;

var updatePlaidItem = function updatePlaidItem(uuid) {
  return /*#__PURE__*/function () {
    var _ref8 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee8(dispatch) {
      return _regenerator.default.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              return _context8.abrupt("return", (0, _ajax.ajaxPost)(UPDATE_PLAID_ITEM, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(PLAID_CONTEXT, "/refresh/asset/").concat(uuid)));

            case 1:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));

    return function (_x8) {
      return _ref8.apply(this, arguments);
    };
  }();
};
/**
 * Delete plaid item by uuid.
 * @param {String} uuid
 */


exports.updatePlaidItem = updatePlaidItem;

var deletePlaidItem = function deletePlaidItem(uuid) {
  return /*#__PURE__*/function () {
    var _ref9 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee9(dispatch) {
      return _regenerator.default.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              return _context9.abrupt("return", (0, _ajax.ajaxPost)(DELETE_PLAID_ITEM, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(PLAID_CONTEXT, "/delete/").concat(uuid)));

            case 1:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }));

    return function (_x9) {
      return _ref9.apply(this, arguments);
    };
  }();
};

exports.deletePlaidItem = deletePlaidItem;

var updatePlaidItems = function updatePlaidItems() {
  return /*#__PURE__*/function () {
    var _ref10 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee10(dispatch) {
      return _regenerator.default.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              return _context10.abrupt("return", (0, _ajax.ajaxPost)(UPDATE_PLAID_ITEMS, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(PLAID_CONTEXT, "/update/expiredAssets")));

            case 1:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }));

    return function (_x10) {
      return _ref10.apply(this, arguments);
    };
  }();
};

exports.updatePlaidItems = updatePlaidItems;